import type { CalendarEvent } from 'paintscout'

export function groupMonthViewEventsByEstimator(events: CalendarEvent[]) {
  // Flatten all events and their subsequentEvents into a single array
  const flatEvents: CalendarEvent[] = []
  for (const event of events) {
    flatEvents.push(event)
    if (event.subsequentEvents && event.subsequentEvents.length > 0) {
      flatEvents.push(...event.subsequentEvents)
    }
  }

  // Group by estimator id
  const grouped: Record<string, CalendarEvent[]> = {}
  flatEvents.forEach((event) => {
    const key = event?.estimator?.id || 'ungrouped'
    if (!grouped[key]) grouped[key] = []
    grouped[key].push(event)
  })

  // For each group, pick the earliest event as primary, rest as subsequent
  return Object.values(grouped)
    .map((group) => {
      if (group.length === 0) return null
      // Sort by start time
      const sorted = group.slice().sort((a, b) => new Date(a.start).getTime() - new Date(b.start).getTime())
      const [primary, ...subsequent] = sorted
      return {
        ...primary,
        subsequentEvents: subsequent
      }
    })
    .filter(Boolean)
}
